import { render, staticRenderFns } from "./LifetimeFooter.vue?vue&type=template&id=91d2c5ec"
import script from "./LifetimeFooter.vue?vue&type=script&lang=js"
export * from "./LifetimeFooter.vue?vue&type=script&lang=js"
import style0 from "./LifetimeFooter.vue?vue&type=style&index=0&id=91d2c5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports